import { ReactNode, useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

type Props = { children: ReactNode; roles?: string[] };

export default function ProtectedRoute({ children, roles }: Props) {
  const [allowed, setAllowed] = useState<boolean | null>(null);

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch('/auth/me', { credentials: 'include' });
        if (!res.ok) return setAllowed(false);
        const data = await res.json();
        if (!roles || roles.length === 0) return setAllowed(true);
        const userRoles: string[] = data.roles || [];
        // Super admin has access to everything
        if (userRoles.includes('superadmin')) return setAllowed(true);
        setAllowed(roles.some(r => userRoles.includes(r)));
      } catch {
        setAllowed(false);
      }
    })();
  }, [roles?.join(',')]);

  if (allowed === null) return <div className="p-4 text-center text-sm text-muted-foreground">Loading...</div>;
  return allowed ? <>{children}</> : <Navigate to="/login" replace />;
}
